module.exports = {
    PUSH_STATUS: Object.freeze({
        CREATED: 1,
        WAITING: 5,
        PROCESSING: 2,
        SUCCESS: 3,
        FAIL: 4,
        CANCELED: 6
    }),
    PUSH_STATUS_TITLE: Object.freeze({
        1: 'Создан',
        2: 'Отправляется',
        3: 'Успешно отправлен',
        4: 'Завершен с ошибкой',
        5: 'Отправляется',
        6: 'Отменен',
    }),
};
